<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">样本册：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="样本册"
                clearable
                v-model="queryData.product_name"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">部品：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="部品"
                clearable
                v-model="queryData.base_material_name"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="样本册"
            prop="product_name"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="部品"
            prop="base_material_name"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="实际送货数量"
            prop="fact_number"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: [],
      selectedIds: [],
      // 分页
      queryData: {
        product_name: "",
        base_material_name: "",
        outsource_company_id: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      outsource_company_id: sessionStorage.getItem("outsource_company_id")
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.queryData.outsource_company_id = _this.outsource_company_id;
      _this.post(_this.$apis.getDeliveryNumberList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.product_name = "";
        this.queryData.base_material_name = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    }
  },
  components: {}
};
</script>
